import { __decorate } from "tslib";
import { module } from 'angular';
import { NgModule } from 'angular-ts-decorators';
import { SharedModule } from 'src/shared';
import { ApplicationSpotController } from './application-spot/application-spot.controller';
import { FirmwareUpdateSpotController } from './firmware-update-spot/firmware-update-spot.controller';
import { SoftwareSpotController } from './software-spot/software-spot.controller';
import { ReleaseNotesService } from './services/release-notes.service';
import { SupportDesignModule } from 'src/Foundation/Design/app';
var moduleId = 'gn.audio.support.software';
var legacyModuleId = moduleId + ".legacy";
module(legacyModuleId, [])
    .controller('ApplicationSpotController', ApplicationSpotController)
    .controller('FirmwareUpdateSpotController', FirmwareUpdateSpotController)
    .controller('SoftwareSpotController', SoftwareSpotController);
var SoftwareModule = (function () {
    function SoftwareModule() {
    }
    SoftwareModule = __decorate([
        NgModule({
            declarations: [],
            id: moduleId,
            imports: [SupportDesignModule, legacyModuleId, SharedModule],
            providers: [ReleaseNotesService],
        })
    ], SoftwareModule);
    return SoftwareModule;
}());
export { SoftwareModule };
